<template>
  <div>
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="4" :sm="24">
            <a-form-item label="名称">
              <a-input v-model="queryParam.name" placeholder="名称" allow-clear/>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="24">
            <a-form-item label="编码">
              <a-input v-model="queryParam.code" placeholder="编码" allow-clear/>
            </a-form-item>
          </a-col>
          <a-col :md="2" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
            </span>
          </a-col>
          <a-col :md="2" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleAdd">新建</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <s-table
      ref="table"
      size="small"
      rowKey="id"
      :loading="loading"
      :columns="columns"
      :data="loadData"
    >
      <span slot="serial" slot-scope="text, record, index">
        {{ index + 1 }}
      </span>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-popconfirm
            title="确定要删除么？"
            ok-text="确定"
            cancel-text="取消"
            @confirm="handleDelet(record)"
          >
            <a>删除</a>
          </a-popconfirm>
        </template>
      </span>
    </s-table>
    <create-form
      ref="createModal"
      :visible="visible"
      :loading="confirmLoading"
      :model="mdl"
      @cancel="handleAddCancel"
      @ok="handleOk"
    />
  </div>
</template>

<script>
import { STable } from '@/components'
import { category_list, category_create, category_delete } from '@/api/trade_category'
import { Dictionaries } from '@/common/AllConstant'
import CreateForm from '../modules/CreateForm'

export default {
  name: 'TableList',
  components: {
    STable,
    CreateForm
  },
  data () {
    return {
      loading: false,
      confirmLoading: false,
      dictionaries: Dictionaries,
      // 创建窗口控制
      visible: false,
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '编码',
          dataIndex: 'code',
          width: 160,
          ellipsis: true,
          customRender: (text, record) => record.parent_category_id === -1 ? (record.part_code === '' ? record.code : text) : text
        },
        {
          title: '名称',
          dataIndex: 'name',
          width: 200,
          ellipsis: true
        },
        {
          title: '金蝶物料编码',
          dataIndex: 'jd_code',
          width: 100,
          ellipsis: true
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '150px',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return category_list(Object.assign(parameter, this.queryParam))
          .then(res => {
            const mapData = this.buildTree(res.data.entries)
            return { entries: mapData }
          })
      },
      selectedRowKeys: [],
      selectedRows: [],

      // custom table alert & rowSelection
      options: {
        alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
        rowSelection: {
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      optionAlertShow: false
    }
  },
  created () {
    this.tableOption()
  },
  methods: {
    buildTree (categories) {
      const idToNodeMap = {}
      const tree = []

      // 初始化每个节点
      categories.forEach(category => {
        idToNodeMap[category.id] = { ...category, children: undefined }
      })

      // 构建树状结构
      categories.forEach(category => {
        const parentId = category.parent_category_id
        if (parentId === -1) {
          // 根节点直接加入树
          tree.push(idToNodeMap[category.id])
        } else {
          // const parentNode = idToNodeMap[parentId]
          // if (parentNode) {
          //   parentNode.children.push(idToNodeMap[category.id])
          // } else {
          //   // 可选：处理孤儿节点（比如也当作根节点，或打印警告）
          //   console.warn(`Orphan node: ${category.name} (id=${category.id}), parent id=${parentId} not found.`)
          //   // tree.push(idToNodeMap[category.id]) // 如果你想保留孤儿节点
          // }
          // 子节点加入父节点的 children 中
          if (idToNodeMap[category.id]) {
            console.log('----idToNodeMap--->>>>>>>>>>', idToNodeMap, '====', idToNodeMap[parentId])
            if (idToNodeMap[parentId] === undefined || idToNodeMap[parentId].children === undefined) {
              idToNodeMap[parentId].children = []
            }
            idToNodeMap[parentId].children.push(idToNodeMap[category.id])
          }
        }
      })
      return tree
    },
    tableOption () {
      if (!this.optionAlertShow) {
        this.options = {
          alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    handleAdd () {
      // const date = new Date()
      // this.mdl = { code: date.getFullYear() + '' + (date.getMonth() + 1) + date.getDate() }
      this.visible = true
    },
    handleAddCancel () {
      this.visible = false

      const form = this.$refs.createModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleEdit (record) {
      // this.$emit('onEdit', record)
      this.$router.push({ path: '/trade/category/' + record.id })
    },
    handleDelet (record) {
      console.log('===========delete===', record)
      category_delete(record.id).then((res) => {
        if (res.code === 1000) {
          this.$refs.table.refresh()
        }
      })
    },
    handleOk () {
      const form = this.$refs.createModal.form
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log('values', values)
            // 新增
          this.confirmLoading = true
          category_create(values).then(res => {
              // 刷新表格
              if (res.code === 1000) {
                this.visible = false
                // 重置表单数据
                form.resetFields()
                this.$refs.table.refresh()
              }
          }).finally(() => {
            this.confirmLoading = false
          })
        }
      })
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    }
  }
}
</script>
